export default __webpack_public_path__ + "static/business-case-hero-33edd2e67c24effd7d8882400d81b2bf.jpg";